<template>
    <div class="wp_mainFooterContainer">
      <div class="container wp_FooterContainer">
        <div class="row pt-3 pb-3 m-0">
          <component :is="widget.variable"
          v-for="(widget, widgetkey) in data.containerAreaModules"
        :key="widgetkey"
        :data="widget.widgetProperties"
      ></component>

        </div>
      </div>
    </div>
</template>

<script>

import FooterPayments from '@/components/shared/footer/footerComponents/footerContainerModules/FooterPayments'
import FooterAbout from '@/components/shared/footer/footerComponents/footerContainerModules/FooterAbout'
import FooterNewsletter from '@/components/shared/footer/footerComponents/footerContainerModules/FooterNewsletter'
import FooterContact from '@/components/shared/footer/footerComponents/footerContainerModules/FooterContact'

export default {
	props: {
		data: {
			type: Object
		}
	},
	components: {
		'payment': FooterPayments,
		'about': FooterAbout,
		'newsletter': FooterNewsletter,
		'contact': FooterContact
	}
}
</script>
